import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, map, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ErrorHandlingService } from '../general/error-handling.service';
import { IResultsGuided } from 'src/app/interfaces/iresults-guided';
import { IPathwayQuizResult } from 'src/app/interfaces/ipathway-quiz-result';

@Injectable({
  providedIn: 'root'
})
export class ResultsGuidedService {

  backendUrl:string = environment.backendUrl; 

  constructor(private http: HttpClient, private errorHandlingService: ErrorHandlingService) {}

  getResultsGuidedData(practiceCallUuid: string): Observable<IResultsGuided> {
    return this.http
      .get<IResultsGuided>(
        `${this.backendUrl}/results/getGuidedResult/?practiceCallUuid=${practiceCallUuid}`
      )
      .pipe(
        map((result) => result),
        tap((res) => {
          const outcome = res ? 'fetched' : 'did not find';
          console.log(`guided results: ${outcome}`);
        }),
        catchError((error) => {
          if (error.status === 500) {
            console.error('Error:', error);
            throw error;
          } else {
            return this.errorHandlingService.handleError<any>(`guided_results`)(error);
          }
        }),
      );
  }

  getPathwayQuizResultData(
    practiceCallUuid: string
  ): Observable<IPathwayQuizResult> {
    return this.http
      .get<IPathwayQuizResult>(
        `${this.backendUrl}/results/getPathwayQuizResult/?practiceCallUuid=${practiceCallUuid}`
      )
      .pipe(
        map((result) => result),
        tap((res) => {
          const outcome = res ? 'fetched' : 'did not find';
          console.log(`pathway quiz results: ${outcome}`);
        }),
        catchError((error) => {
          if (error.status === 500) {
            console.error('Error:', error);
            throw error;
          } else {
            return this.errorHandlingService.handleError<any>(
              `pathway_quiz_results`
            )(error);
          }
        })
      );
  }
}
